import { forward, toPoint } from "mgrs";
import { getWsInstance } from "../../api/WsManagement";
import { Vec3 } from "../../models/SyntheticMap";
import { Tile3DFactory } from "../threeDComponents/Tile3DFactory";
import { gpsToOffset, offsetToGps } from "../../utils/googleMaps";

export function getMrgsFromLocation(loc: Vec3): string {
  const uiService = getWsInstance().uiService;
  const tile3DFactory = uiService.getFactory(Tile3DFactory);
  const site = tile3DFactory.site;
  const [lng, lat] = toPoint(site.location);
  const latLngAlt = new google.maps.LatLngAltitude({
    lat: lat,
    lng: lng,
    altitude: site.elevation || 0,
  });
  const posit = offsetToGps(latLngAlt, loc);
  return forward([posit.lng, posit.lat]); // convert to MGRS with 5 digits accuracy
}

export function getLocationFromMgrs(mgrs: string): Vec3 {
  const uiService = getWsInstance().uiService;
  const tile3DFactory = uiService.getFactory(Tile3DFactory);
  const site = tile3DFactory.site;
  const [centerLng, centerLat] = toPoint(site.location);
  const center = new google.maps.LatLngAltitude({
    lat: centerLat,
    lng: centerLng,
    altitude: site.elevation || 0,
  });
  // Convert MGRS to point
  const [pontLng, pointLat] = toPoint(mgrs);
  const point = new google.maps.LatLngAltitude({
    lat: pointLat,
    lng: pontLng,
    altitude: site.elevation, // Altitude can be set to 0 or a specific value
  });
  return gpsToOffset(center, point);
  // return offsetToGps(latLngAlt, { x: point[0], y: point[1], z: 0 });
}